<template>
  <div v-if="data">
    <div class="mt-3">{{data.first_name}} {{data.last_name}}</div>
    <div class="">{{data.company}}</div>
    <div class="">{{data.street1}}</div>
    <div class="">{{data.street2}}</div>
    <div class="">{{data.city}}, {{data.state}}  {{data.zip}}</div>
    <div class="">{{data.country_name}}</div>
    <div class="">{{data.email}}</div>
    <div class="">{{data.phone}}</div>
  </div>
</template>

<script>
  export default {
    props: {
      data: { type: Object }
    }
  }
</script>



// WEBPACK FOOTER //
// display-address.vue?2bc6f77b